import { NgModule } from "@angular/core";
import { AuthModule } from "app/core/auth/auth.module";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { NgOptimizedImage } from "@angular/common";
import { PortalModule } from "@angular/cdk/portal";
import { ThemeModule } from "app/core/theme/theme.module";
import { TranslateService } from "@ngx-translate/core";
import { AuthGuard } from "app/core/guards/auth.guard";
import { CookieService } from "ngx-cookie-service";
import { SnackBarService } from "app/core/services/snackbar.service";
import { AdminService } from "app/core/services/admin.service";
import { LicenseService } from "app/core/services/license.service";
import { RouterEventService } from "app/core/services/router-event.service";
import { SearchService } from "app/core/services/search.service";
import { OverlayContainerService } from "./services/overlay-container.service";

@NgModule({
  declarations: [],
  imports: [AuthModule.forRoot(), NgOptimizedImage, PortalModule, ThemeModule],
  providers: [
    AdminService,
    AuthGuard,
    CookieService,
    LicenseService,
    SnackBarService,
    TranslateService,
    RouterEventService,
    SearchService,
    OverlayContainerService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
